import { byId } from './domUtils';
import { disposeKeywordCloud } from './keywordCloud';
import type { Root } from './prototypeTypes';
import { topicCtaLoadingMarkup } from '../../shared/playerIcons';

export function paintTopicChapterSkeleton(root: Root): void {
	const list = byId(root, 'topicChapterItems');
	if (!list) return;
	list.replaceChildren(
		...Array.from({ length: 5 }, () => {
			const row = document.createElement('div');
			row.className = 'topic-chapter-skeleton';
			return row;
		}),
	);
}

export function resetTopicOptionalPresentation(root: Root): void {
	const pills = byId(root, 'topic-hero-pills');
	if (pills) {
		pills.hidden = true;
		pills.replaceChildren();
	}
	const actions = byId(root, 'topic-hero-actions');
	if (actions) actions.hidden = true;
	paintTopicPrimaryActionLoading(root);
	const outcomes = byId(root, 'topic-outcomes-block');
	const cloud = byId(root, 'topic-keyword-cloud');
	disposeKeywordCloud(cloud);
	if (cloud) {
		cloud.replaceChildren();
		cloud.classList.remove('kw-cloud-3d', 'kw-cloud--skeleton', 'topic-keyword-cloud--static');
	}
	if (outcomes) outcomes.hidden = false;
	byId(root, 'topic-faq-block')?.replaceChildren();
	const premium = byId(root, 'topicPremiumUnlocks');
	if (premium) premium.style.display = 'none';
	byId(root, 'topicPremiumPills')?.replaceChildren();
}

/**
 * A warm Topic can have its poster text immediately while its chapter and
 * resume data are still in flight. Keep the CTA's final-size loading shape in
 * that interval so an old "View chapters" action cannot flash over it.
 */
export function paintTopicPrimaryActionLoading(root: Root, options: { warmTopic?: boolean } = {}): void {
	const primaryAction = byId(root, 'topicPrimaryCta');
	if (!primaryAction) return;
	primaryAction.removeAttribute('href');
	primaryAction.removeAttribute('data-proto-click');
	primaryAction.classList.add('loading');
	primaryAction.setAttribute('aria-busy', 'true');
	primaryAction.setAttribute('aria-label', 'Loading next chapter');
	if (options.warmTopic) primaryAction.dataset.topicWarmActionPending = 'true';
	else delete primaryAction.dataset.topicWarmActionPending;
	const template = document.createElement('template');
	template.innerHTML = topicCtaLoadingMarkup();
	primaryAction.replaceChildren(template.content);
}
